import {useEffect} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {getAnalyticsSessionId} from "@pg-mono/algolytics";
import {useUserDevice} from "@pg-mono/user-device";

import {startRegistrationFlowForCurrentUser} from "../../../auth/actions/start_registration_flow_for_current_user";
import {AuthModalVariant} from "../../../auth/components/auth_modal/AuthModalHeaderVariants";
import {REGISTRATION_FLOW_ABOVE_AI_ASSISTANT_Z_INDEX} from "../../../auth/constants/registration_flow_modal_z_index";
import {IRegistrationFlowControlAuthClick, RegistrationFlowControlAction} from "../../../auth/types/RegistrationFlowControlAction";
import {RegistrationWizardAccountEntry} from "../../../auth/types/RegistrationWizardEntry";
import {useShouldHidePrices} from "../../../hooks/use_should_hide_prices";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {getSemanticSearchModalSize} from "../../tracking/get_semantic_search_modal_size";
import {SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT, SEMANTIC_SEARCH_AMPLITUDE_LOCATION} from "../../tracking/semantic_search_amplitude_location";
import {AI_ASSISTANT_AUTH_CUSTOM_LABEL, hitAiAssistantCta} from "../../tracking/semantic_search_gtm_events";
import {trackAmplitudeAiSignModalView} from "../../tracking/track_amplitude_ai_sign_modal_view";

type SemanticSearchAuthMode = "login" | "signup";

const AUTH_CLICKS: Record<SemanticSearchAuthMode, IRegistrationFlowControlAuthClick> = {
    login: {
        event: "login_click",
        params: {loginMethod: "internal", loginPlacement: SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT, location: SEMANTIC_SEARCH_AMPLITUDE_LOCATION}
    },
    signup: {
        event: "sign_up_click",
        params: {signUpMethod: "internal", signUpPlacement: SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT, location: SEMANTIC_SEARCH_AMPLITUDE_LOCATION}
    }
};

export const SemanticSearchSignup = () => {
    const dispatch = useAppDispatch();
    const {isMobile} = useUserDevice();
    const surfacePhase = useAppSelector((state) => state.semanticSearchModal.surfacePhase);
    const isSemanticSearchOpen = surfacePhase === "fullscreen";
    const {isUserLoggedIn, hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();

    useEffect(() => {
        trackAmplitudeAiSignModalView(getSemanticSearchModalSize(surfacePhase), getAnalyticsSessionId());
    }, []);

    const getControlAction = (authMode: SemanticSearchAuthMode): RegistrationFlowControlAction => {
        const amplitudeAuthClick = AUTH_CLICKS[authMode];

        // Use this login/register variant when user is using fullscreen modal for AI advisor
        if (isSemanticSearchOpen && !isMobile) {
            return {
                type: "registration_flow",
                flow: {
                    isUserLoggedIn,
                    hasCompleteProfile,
                    hasPhoneVerified,
                    userSource: UserSource.HIDDEN_PRICES_BANNER,
                    gtmSourceSection: AI_ASSISTANT_AUTH_CUSTOM_LABEL,
                    modalVariant: "hidden_prices_variant_b",
                    titleVariant: AuthModalVariant.HIDDEN_PRICES_VARIANT_B,
                    showLoginForm: authMode === "login",
                    amplitudePlacement: SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT,
                    amplitudeLocation: SEMANTIC_SEARCH_AMPLITUDE_LOCATION
                },
                amplitudeAuthClick
            };
        }

        return {type: "semantic_search_auth_drawer", drawer: authMode, amplitudeAuthClick};
    };

    const startAuthFlow = (authMode: SemanticSearchAuthMode) => {
        dispatch(
            startRegistrationFlowForCurrentUser(
                {
                    userSource: UserSource.HIDDEN_PRICES_BANNER,
                    gtmSourceSection: AI_ASSISTANT_AUTH_CUSTOM_LABEL,
                    wizardEntry: RegistrationWizardAccountEntry.AI_ASSISTANT,
                    amplitudePlacement: SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT,
                    amplitudeLocation: SEMANTIC_SEARCH_AMPLITUDE_LOCATION,
                    modalZIndex: REGISTRATION_FLOW_ABOVE_AI_ASSISTANT_Z_INDEX
                },
                getControlAction(authMode)
            )
        );
    };

    const handleSignupClick = () => {
        hitAiAssistantCta("click", "Załóż konto");
        startAuthFlow("signup");
    };

    const handleLoginClick = () => {
        hitAiAssistantCta("click", "Zaloguj się");
        startAuthFlow("login");
    };

    return (
        <div className={signupButtonWrapper}>
            <Button variant="filled_primary" size="x-small" onClick={handleSignupClick}>
                Załóż konto
            </Button>
            <Button variant="outlined_secondary" size="x-small" onClick={handleLoginClick}>
                Zaloguj się
            </Button>
        </div>
    );
};

const signupButtonWrapper = css({
    display: "flex",
    gap: 2
});
import {useEffect} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {getAnalyticsSessionId} from "@pg-mono/algolytics";
import {useUserDevice} from "@pg-mono/user-device";

import {startRegistrationFlowForCurrentUser} from "../../../auth/actions/start_registration_flow_for_current_user";
import {AuthModalVariant} from "../../../auth/components/auth_modal/AuthModalHeaderVariants";
import {REGISTRATION_FLOW_ABOVE_AI_ASSISTANT_Z_INDEX} from "../../../auth/constants/registration_flow_modal_z_index";
import {IRegistrationFlowControlAuthClick, RegistrationFlowControlAction} from "../../../auth/types/RegistrationFlowControlAction";
import {RegistrationWizardAccountEntry} from "../../../auth/types/RegistrationWizardEntry";
import {useShouldHidePrices} from "../../../hooks/use_should_hide_prices";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {getSemanticSearchModalSize} from "../../tracking/get_semantic_search_modal_size";
import {SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT, SEMANTIC_SEARCH_AMPLITUDE_LOCATION} from "../../tracking/semantic_search_amplitude_location";
import {AI_ASSISTANT_AUTH_CUSTOM_LABEL, hitAiAssistantCta} from "../../tracking/semantic_search_gtm_events";
import {trackAmplitudeAiSignModalView} from "../../tracking/track_amplitude_ai_sign_modal_view";

type SemanticSearchAuthMode = "login" | "signup";

const AUTH_CLICKS: Record<SemanticSearchAuthMode, IRegistrationFlowControlAuthClick> = {
    login: {
        event: "login_click",
        params: {loginMethod: "internal", loginPlacement: SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT, location: SEMANTIC_SEARCH_AMPLITUDE_LOCATION}
    },
    signup: {
        event: "sign_up_click",
        params: {signUpMethod: "internal", signUpPlacement: SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT, location: SEMANTIC_SEARCH_AMPLITUDE_LOCATION}
    }
};

export const SemanticSearchSignup = () => {
    const dispatch = useAppDispatch();
    const {isMobile} = useUserDevice();
    const surfacePhase = useAppSelector((state) => state.semanticSearchModal.surfacePhase);
    const isSemanticSearchOpen = surfacePhase === "fullscreen";
    const {isUserLoggedIn, hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();

    useEffect(() => {
        trackAmplitudeAiSignModalView(getSemanticSearchModalSize(surfacePhase), getAnalyticsSessionId());
    }, []);

    const getControlAction = (authMode: SemanticSearchAuthMode): RegistrationFlowControlAction => {
        const amplitudeAuthClick = AUTH_CLICKS[authMode];

        // Use this login/register variant when user is using fullscreen modal for AI advisor
        if (isSemanticSearchOpen && !isMobile) {
            return {
                type: "registration_flow",
                flow: {
                    isUserLoggedIn,
                    hasCompleteProfile,
                    hasPhoneVerified,
                    userSource: UserSource.HIDDEN_PRICES_BANNER,
                    gtmSourceSection: AI_ASSISTANT_AUTH_CUSTOM_LABEL,
                    modalVariant: "hidden_prices_variant_b",
                    titleVariant: AuthModalVariant.HIDDEN_PRICES_VARIANT_B,
                    showLoginForm: authMode === "login",
                    amplitudePlacement: SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT,
                    amplitudeLocation: SEMANTIC_SEARCH_AMPLITUDE_LOCATION
                },
                amplitudeAuthClick
            };
        }

        return {type: "semantic_search_auth_drawer", drawer: authMode, amplitudeAuthClick};
    };

    const startAuthFlow = (authMode: SemanticSearchAuthMode) => {
        dispatch(
            startRegistrationFlowForCurrentUser(
                {
                    userSource: UserSource.HIDDEN_PRICES_BANNER,
                    gtmSourceSection: AI_ASSISTANT_AUTH_CUSTOM_LABEL,
                    wizardEntry: RegistrationWizardAccountEntry.AI_ASSISTANT,
                    amplitudePlacement: SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT,
                    amplitudeLocation: SEMANTIC_SEARCH_AMPLITUDE_LOCATION,
                    modalZIndex: REGISTRATION_FLOW_ABOVE_AI_ASSISTANT_Z_INDEX
                },
                getControlAction(authMode)
            )
        );
    };

    const handleSignupClick = () => {
        hitAiAssistantCta("click", "Załóż konto");
        startAuthFlow("signup");
    };

    const handleLoginClick = () => {
        hitAiAssistantCta("click", "Zaloguj się");
        startAuthFlow("login");
    };

    return (
        <div className={signupButtonWrapper}>
            <Button variant="filled_primary" size="x-small" onClick={handleSignupClick}>
                Załóż konto
            </Button>
            <Button variant="outlined_secondary" size="x-small" onClick={handleLoginClick}>
                Zaloguj się
            </Button>
        </div>
    );
};

const signupButtonWrapper = css({
    display: "flex",
    gap: 2
});
